<!--
  - ===========================================================================
  - [StrongGate Limited] [http://www.stronggate.com]
  - Copyright (c) 2026. All rights Reserved.
  - Unauthorized access, use, dissemination, distribution, reproduction of this
  - file, or a portion of, in any form is prohibited and unlawful. If you receive
  - this file, and you are not an authorized company employee, or you believe you
  - have received this file in error, please notify the sender (or originator)
  - and promptly delete this file.
  -
  - Project:
  - File: side-bar.vue
  - Created by: chan.ying
  - Create Date: 2026-04-27 15:52
  - Version Number: 1.0
  - Version Description:
  -
  - =============================================================================
  -->

<script>
// import {SimpleBar} from "simplebar-vue3"
import SideNav from "./side-nav";
import {layoutComputed} from "@/state/helpers";

/**
 * Sidebar component
 */
export default {
  components: {
    // SimpleBar,
    SideNav
  },
  props: {
    isCondensed: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...layoutComputed,
  },
  data() {
    return {
      menu: {
        isCollapse: false,
      },
    };
  },
};
</script>

<template>
  <div class="vertical-menu menu-container" style="background-color: var(--sidebar-background)">
    <!--    <SimpleBar class="h-100" ref="currentMenu" id="my-element">-->
    <SideNav :is-collapse="menu.isCollapse"/>
    <!--    </SimpleBar>-->
  </div>
</template>


<style scoped>
.menu-container {
  height: auto;
  overflow-y: auto;
  /*
    width: 270px;
    z-index: 1001;
    background: var(--bg-background);
    bottom: 0;
    margin-top: 0;
    position: fixed;
    top: 70px;*/
}
</style>
